import { Component, input, output, inject, viewChild } from '@angular/core';
import {
  MobiUiTypeaheadComponent,
  MobiUiTypeaheadComponents,
} from '@mobi/rwc-ui-components-ng-jslib';
import { BreakpointService } from '@app/services/breakpoint.service';
import { SearchTerm } from '@app/models/global.model';
import { TextsPipe } from '@app/pipes/texts.pipe';
import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';

@Component({
  selector: 'mobi-ga-search-field',
  standalone: true,
  imports: [MobiUiTypeaheadComponents, MobiUiIconComponent, TextsPipe],
  templateUrl: './search-field.component.html',
  styleUrl: './search-field.component.scss',
})
export class SearchFieldComponent {
  readonly showMap = input(true);
  readonly searchTerm = input('');
  readonly searchMatches = input<SearchTerm[]>([]);

  readonly searchTermChange = output<string>();
  readonly valueChange = output<string>();

  readonly typeahead = viewChild<MobiUiTypeaheadComponent>(MobiUiTypeaheadComponent);
  breakpoint = inject(BreakpointService);

  onSearchTermChange(term: string): void {
    this.searchTermChange.emit(term);
  }

  onValueChanges(term: string): void {
    this.valueChange.emit(term);
  }
}
